import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../api/package";

const Packages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const userRole = localStorage.getItem("role");
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        let response;
        if (
          userRole === "event-manager" ||
          userRole === "event-agency" ||
          userRole === "independent"
        ) {
          response = await api.getManagerPackages(userId);
        } else {
          response = await api.getAllPackages();
        }
        setPackages(response.data);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch packages");
        setLoading(false);
      }
    };

    fetchPackages();
  }, [userRole, userId]);

  const handleDelete = async (packageId) => {
    if (window.confirm("Are you sure you want to delete this package?")) {
      try {
        await api.deletePackage(packageId);
        setPackages(packages.filter((pkg) => pkg._id !== packageId));
      } catch (err) {
        setError("Failed to delete package");
      }
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-[#FF4C18]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div
          className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-lg shadow-lg"
          role="alert"
        >
          <p className="font-bold">Error</p>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-15 lg:pt-2">
      <div className="max-w-7xl mx-auto px-4 py-20  sm:px-6 lg:px-  sm:py-20">
        <div className="flex flex-col md:flex-row items-center justify-between mb-12">
          {userRole === "event-manager" ||
          userRole === "event-agency" ||
          userRole === "independent" ? (
            <>
              <div className="flex flex-col gap-4">
                <h1 className="text-3xl font-bold text-black">
                  Create event packages
                </h1>
                <p className="text-black font-regular">
                  Build personalized event packages tailored to your clients’
                  needs.
                </p>
              </div>
              <Link
                to="/dashboard/manager/create-package"
                className="inline-block bg-[#FF4C18] text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#FF4C18] focus:ring-opacity-50"
              >
                Create New Package
              </Link>
            </>
          ) : (
            <div className="flex flex-col gap-4">
              <h1 className="text-3xl font-bold text-black">
                Browse event packages
              </h1>
              <p className="text-black font-regular">
                Browse ready to party event packages, Book a hassle free
                celebration solution delivered to your doorstep.
              </p>
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {packages.map((pkg) => (
            <div
              key={pkg._id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="flex items-center justify-center bg-[#FF4C18] p-8">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-12 w-12 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                  />
                </svg>
              </div>
              <div className="p-6">
                <h2 className="text-2xl font-semibold text-[#FF4C18] mb-2">
                  {pkg.title}
                </h2>
                <p className="text-gray-600 mb-4">{pkg.description}</p>
                <div className="flex justify-between items-center mb-4">
                  <p className="text-[#FF4C18] text-lg font-bold">
                    Budget: ₹ {pkg.budget}
                  </p>
                  <span className="bg-[#FF4C18] text-white text-sm font-medium mr-2 px-2.5 py-0.5 rounded">
                    {pkg.eventType}
                  </span>
                </div>
                <h3 className="text-[#FF4C18] font-semibold mb-2">
                  Services Included:
                </h3>
                <ul className="space-y-2 mb-6">
                  {pkg.servicesIncluded.map((service, index) => (
                    <li key={index} className="flex items-center text-gray-600">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 mr-3 text-green-500"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      {service}
                    </li>
                  ))}
                </ul>
                <div className="mb-6">
                  <h3 className="text-[#FF4C18] font-semibold mb-2">
                    Available Cities:
                  </h3>
                  <div className="flex flex-wrap gap-2">
                    {pkg.availableCities.map((city, index) => (
                      <span
                        key={index}
                        className="bg-gray-100 text-gray-800 text-xs font-medium px-2.5 py-0.5 rounded"
                      >
                        {city}
                      </span>
                    ))}
                  </div>
                </div>
                {(userRole === "event-manager" ||
                  userRole === "event-agency" ||
                  userRole === "independent") && (
                  <div className="flex flex-col sm:flex-row justify-between gap-2">
                    <Link
                      to={`/dashboard/manager/edit-package/${pkg._id}`}
                      className="flex-1 bg-[#FF4C18] text-white py-2 px-4 rounded-lg hover:bg-orange-600 transition duration-300 text-center transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#FF4C18] focus:ring-opacity-50"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(pkg._id)}
                      className="flex-1 bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600 transition duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
                    >
                      Delete
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Packages;

// import React, { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import api from "../../api/package";
// import {
//   Heart,
//   Briefcase,
//   GraduationCap,
//   Baby,
//   Gift,
//   Music,
//   Users,
//   Calendar,
//   PartyPopper
// } from "lucide-react";

// const currency = new Intl.NumberFormat("en-IN", {
//   style: "currency",
//   currency: "INR",
//   maximumFractionDigits: 0,
// });

// const PlaceholderCard = () => (
//   <div className="animate-pulse bg-white rounded-lg shadow-sm overflow-hidden">
//     <div className="h-40 bg-gray-100" />
//     <div className="p-4">
//       <div className="h-4 bg-gray-200 rounded w-3/4 mb-3" />
//       <div className="h-3 bg-gray-200 rounded w-1/2 mb-4" />
//       <div className="h-3 bg-gray-200 rounded w-full mb-2" />
//       <div className="h-3 bg-gray-200 rounded w-5/6" />
//     </div>
//   </div>
// );

// // Icon mapping based on event type
// const getEventIcon = (eventType) => {
//   const iconMap = {
//     'wedding': Heart,
//     'corporate': Briefcase,
//     'graduation': GraduationCap,
//     'baby shower': Baby,
//     'birthday': Gift,
//     'concert': Music,
//     'conference': Users,
//     'party': PartyPopper,
//     'default': Calendar
//   };

//   const IconComponent = iconMap[eventType?.toLowerCase()] || iconMap.default;
//   return <IconComponent className="h-14 w-14 text-[#FF4C18]" />;
// };

// const PackageCard = ({ pkg, canEdit, onDelete }) => {
//   return (
//     <article
//       className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden hover:shadow-xl transition-shadow duration-200 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[#FF4C18]"
//       aria-labelledby={`pkg-${pkg._id}-title`}
//     >
//       <div
//         className="relative flex items-center justify-center bg-orange-50 p-6"
//         style={{
//           backgroundImage: `
//             linear-gradient(rgba(255, 76, 24, 0.05) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(255, 76, 24, 0.05) 1px, transparent 1px)
//           `,
//           backgroundSize: '20px 20px',
//           backgroundPosition: '0 0, 0 0'
//         }}
//       >
//         <div className="relative z-10">
//           {/* {getEventIcon(pkg.eventType)} */}
//           <svg
//           xmlns="http://www.w3.org/2000/svg"
//           className="h-14 w-14 text-[#FF4C18]"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//           aria-hidden="true"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={1.8}
//             d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
//           />
//         </svg>
//         </div>
//       </div>

//       <div className="p-5 sm:p-6">
//         <h3 id={`pkg-${pkg._id}-title`} className="text-lg font-semibold text-gray-900 mb-1">
//           {pkg.title}
//         </h3>

//         <p className="text-sm text-gray-600 mb-4 line-clamp-3">{pkg.description}</p>

//         <div className="flex items-center justify-between mb-4 gap-3">
//           <div>
//             <p className="text-sm text-gray-500">Budget</p>
//             <p className="text-[#FF4C18] font-bold text-lg">{currency.format(pkg.budget)}</p>
//           </div>

//           <div className="text-right">
//             <span className="inline-block bg-orange-100 text-[#FF4C18] text-xs font-medium px-2.5 py-0.5 rounded">
//               {pkg.eventType}
//             </span>
//           </div>
//         </div>

//         <div className="mb-4">
//           <h4 className="text-sm font-medium text-gray-800 mb-2">Services included</h4>
//           <ul className="text-sm text-gray-600 space-y-1">
//             {pkg.servicesIncluded?.slice(0, 4).map((s, i) => (
//               <li key={i} className="flex items-start gap-2">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mt-1 text-green-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//                 </svg>
//                 <span className="truncate">{s}</span>
//               </li>
//             ))}
//             {pkg.servicesIncluded?.length > 4 && (
//               <li className="text-xs text-gray-400">+{pkg.servicesIncluded.length - 4} more</li>
//             )}
//           </ul>
//         </div>

//         <div className="mb-4">
//           <h4 className="text-sm font-medium text-gray-800 mb-2">Available cities</h4>
//           <div className="flex flex-wrap gap-2">
//             {pkg.availableCities?.map((city, i) => (
//               <span key={i} className="bg-gray-100 text-gray-800 text-xs px-2 py-0.5 rounded">
//                 {city}
//               </span>
//             ))}
//           </div>
//         </div>

//         <div className="flex flex-col sm:flex-row gap-2">
//           <Link
//             to={`/packages/${pkg._id}`}
//             className="inline-flex items-center justify-center px-4 py-2 bg-white border border-gray-200 text-sm rounded-lg hover:bg-gray-50 w-full sm:w-auto"
//           >
//             View
//           </Link>

//           {canEdit ? (
//             <>
//               <Link
//                 to={`/edit-package/${pkg._id}`}
//                 className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 w-full sm:w-auto"
//               >
//                 Edit
//               </Link>
//               <button
//                 onClick={() => onDelete(pkg._id)}
//                 className="inline-flex items-center justify-center px-4 py-2 bg-red-600 text-white text-sm rounded-lg hover:bg-red-700 w-full sm:w-auto"
//                 aria-label={`Delete package ${pkg.title}`}
//               >
//                 Delete
//               </button>
//             </>
//           ) : (
//             <Link
//               to={`/book/${pkg._id}`}
//               className="inline-flex items-center justify-center px-4 py-2 bg-[#FF4C18] text-white text-sm rounded-lg hover:bg-orange-600 w-full sm:w-auto"
//             >
//               Book Now
//             </Link>
//           )}
//         </div>
//       </div>
//     </article>
//   );
// };

// const Packages = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [pageSize] = useState(9); // pagination on client side
//   const [visibleCount, setVisibleCount] = useState(pageSize);
//   const abortRef = useRef(null);

//   const userRole = localStorage.getItem("role");
//   const userId = localStorage.getItem("userId");

//   useEffect(() => {
//     abortRef.current = new AbortController();
//     const signal = abortRef.current.signal;

//     const fetchPackages = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         let response;
//         if (userRole === "event-manager" || userRole === "event-agency") {
//           response = await api.getManagerPackages(userId, { signal });
//         } else {
//           response = await api.getAllPackages({ signal });
//         }
//         // assume response.data is array
//         setPackages(Array.isArray(response.data) ? response.data : []);
//       } catch (err) {
//         if (err.name !== "AbortError") {
//           console.error(err);
//           setError("Failed to fetch packages. Please try again.");
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPackages();

//     return () => {
//       abortRef.current?.abort();
//     };
//   }, [userRole, userId]);

//   // optimistic delete
//   const handleDelete = async (packageId) => {
//     const confirmed = window.confirm("Are you sure you want to delete this package?");
//     if (!confirmed) return;

//     const prev = packages;
//     setPackages((p) => p.filter((x) => x._id !== packageId));

//     try {
//       await api.deletePackage(packageId);
//       // success - already removed
//     } catch (err) {
//       console.error(err);
//       setPackages(prev); // rollback
//       setError("Failed to delete package. Please try again.");
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full max-w-6xl">
//           {Array.from({ length: 6 }).map((_, i) => (
//             <PlaceholderCard key={i} />
//           ))}
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
//         <div className="max-w-xl w-full text-center">
//           <div className="bg-red-50 border border-red-200 text-red-700 p-6 rounded-lg mb-6">
//             <strong className="block text-lg">Error</strong>
//             <p className="mt-2">{error}</p>
//           </div>
//           <div className="flex gap-3 justify-center">
//             <button
//               onClick={() => {
//                 setError(null);
//                 setLoading(true);
//                 // refetch (simple way)
//                 window.location.reload();
//               }}
//               className="px-4 py-2 bg-[#FF4C18] text-white rounded-lg"
//             >
//               Retry
//             </button>
//             <Link to="/" className="px-4 py-2 bg-white border rounded-lg">
//               Return Home
//             </Link>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // empty state
//   if (!packages.length) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
//         <div className="max-w-2xl w-full text-center bg-white p-8 rounded-lg shadow-sm">
//           <h2 className="text-2xl font-semibold mb-2">No packages found</h2>
//           <p className="text-gray-600 mb-6">
//             There are no packages available right now. If you're a manager, create your first package to get started.
//           </p>
//           {userRole === "event-manager" || userRole === "event-agency" ? (
//             <Link
//               to="/create-package"
//               className="inline-block px-6 py-2 bg-[#FF4C18] text-white rounded-lg"
//             >
//               Create a Package
//             </Link>
//           ) : (
//             <Link to="/" className="inline-block px-6 py-2 bg-[#FF4C18] text-white rounded-lg">
//               Browse Events
//             </Link>
//           )}
//         </div>
//       </div>
//     );
//   }

//   // visible packages pagination
//   const visiblePackages = packages.slice(0, visibleCount);
//   const canLoadMore = visibleCount < packages.length;

//   return (
//     <main className="min-h-screen py-12 px-4 sm:px-6 lg:px-8 pt-24">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-0 mb-10">
//           <div className="space-y-2">
//             <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
//               {userRole === "event-manager" || userRole === "event-agency"
//                 ? "Create event packages"
//                 : "Browse event packages"}
//             </h1>
//             <p className="text-sm text-gray-600 max-w-2xl">
//               {userRole === "event-manager" || userRole === "event-agency"
//                 ? "Build personalized event packages tailored to your clients’ needs."
//                 : "Browse ready-to-book event packages — hassle-free celebration solutions."}
//             </p>
//           </div>

//           <div className="flex items-center gap-3">
//             {userRole === "event-manager" || userRole === "event-agency" ? (
//               <Link
//                 to="/create-package"
//                 className="inline-flex items-center justify-center whitespace-nowrap bg-[#FF4C18] hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF4C18]"
//               >
//                 Create New Package
//               </Link>
//             ) : (
//               <Link
//                 to="/packages?filter=popular"
//                 className="inline-flex items-center justify-center whitespace-nowrap bg-[#FF4C18] hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF4C18]"
//               >
//                 Browse popular
//               </Link>
//             )}
//           </div>
//         </div>

//         {/* Grid */}
//         <section aria-label="packages grid">
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             {visiblePackages.map((pkg) => (
//               <PackageCard
//                 key={pkg._id}
//                 pkg={pkg}
//                 canEdit={userRole === "event-manager" || userRole === "event-agency"}
//                 onDelete={handleDelete}
//               />
//             ))}
//           </div>

//           {/* Load more */}
//           {canLoadMore && (
//             <div className="mt-8 flex justify-center">
//               <button
//                 onClick={() => setVisibleCount((c) => c + pageSize)}
//                 className="px-5 py-2 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50"
//               >
//                 Load more
//               </button>
//             </div>
//           )}
//         </section>
//       </div>
//     </main>
//   );
// };

// export default Packages;

// import React, { useEffect, useState, useRef } from "react";
// import { Link } from "react-router-dom";
// import api from "../../api/package";

// const currency = new Intl.NumberFormat("en-IN", {
//   style: "currency",
//   currency: "INR",
//   maximumFractionDigits: 0,
// });

// const PlaceholderCard = () => (
//   <div className="animate-pulse bg-white rounded-lg shadow-sm overflow-hidden">
//     <div className="h-40 bg-gray-100" />
//     <div className="p-4">
//       <div className="h-4 bg-gray-200 rounded w-3/4 mb-3" />
//       <div className="h-3 bg-gray-200 rounded w-1/2 mb-4" />
//       <div className="h-3 bg-gray-200 rounded w-full mb-2" />
//       <div className="h-3 bg-gray-200 rounded w-5/6" />
//     </div>
//   </div>
// );

// const PackageCard = ({ pkg, canEdit, onDelete }) => {
//   return (
//     <article
//       className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-xl transition-shadow duration-200 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-[#FF4C18]"
//       aria-labelledby={`pkg-${pkg._id}-title`}
//     >
//       <div className="flex items-center justify-center bg-purple-50 p-6">
//         {/* Placeholder icon - swap with real image if available */}
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           className="h-14 w-14 text-purple-600"
//           fill="none"
//           viewBox="0 0 24 24"
//           stroke="currentColor"
//           aria-hidden="true"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth={1.8}
//             d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
//           />
//         </svg>
//       </div>

//       <div className="p-5 sm:p-6">
//         <h3 id={`pkg-${pkg._id}-title`} className="text-lg font-semibold text-gray-900 mb-1">
//           {pkg.title}
//         </h3>

//         <p className="text-sm text-gray-600 mb-4 line-clamp-3">{pkg.description}</p>

//         <div className="flex items-center justify-between mb-4 gap-3">
//           <div>
//             <p className="text-sm text-gray-500">Budget</p>
//             <p className="text-purple-700 font-bold text-lg">{currency.format(pkg.budget)}</p>
//           </div>

//           <div className="text-right">
//             <span className="inline-block bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-0.5 rounded">
//               {pkg.eventType}
//             </span>
//           </div>
//         </div>

//         <div className="mb-4">
//           <h4 className="text-sm font-medium text-gray-800 mb-2">Services included</h4>
//           <ul className="text-sm text-gray-600 space-y-1">
//             {pkg.servicesIncluded?.slice(0, 4).map((s, i) => (
//               <li key={i} className="flex items-start gap-2">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mt-1 text-green-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
//                 </svg>
//                 <span className="truncate">{s}</span>
//               </li>
//             ))}
//             {pkg.servicesIncluded?.length > 4 && (
//               <li className="text-xs text-gray-400">+{pkg.servicesIncluded.length - 4} more</li>
//             )}
//           </ul>
//         </div>

//         <div className="mb-4">
//           <h4 className="text-sm font-medium text-gray-800 mb-2">Available cities</h4>
//           <div className="flex flex-wrap gap-2">
//             {pkg.availableCities?.map((city, i) => (
//               <span key={i} className="bg-gray-100 text-gray-800 text-xs px-2 py-0.5 rounded">
//                 {city}
//               </span>
//             ))}
//           </div>
//         </div>

//         <div className="flex flex-col sm:flex-row gap-2">
//           <Link
//             to={`/packages/${pkg._id}`}
//             className="inline-flex items-center justify-center px-4 py-2 bg-white border border-gray-200 text-sm rounded-lg hover:bg-gray-50 w-full sm:w-auto"
//           >
//             View
//           </Link>

//           {canEdit ? (
//             <>
//               <Link
//                 to={`/edit-package/${pkg._id}`}
//                 className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 w-full sm:w-auto"
//               >
//                 Edit
//               </Link>
//               <button
//                 onClick={() => onDelete(pkg._id)}
//                 className="inline-flex items-center justify-center px-4 py-2 bg-red-600 text-white text-sm rounded-lg hover:bg-red-700 w-full sm:w-auto"
//                 aria-label={`Delete package ${pkg.title}`}
//               >
//                 Delete
//               </button>
//             </>
//           ) : (
//             <Link
//               to={`/book/${pkg._id}`}
//               className="inline-flex items-center justify-center px-4 py-2 bg-[#FF4C18] text-white text-sm rounded-lg hover:bg-orange-600 w-full sm:w-auto"
//             >
//               Book Now
//             </Link>
//           )}
//         </div>
//       </div>
//     </article>
//   );
// };

// const Packages = () => {
//   const [packages, setPackages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [pageSize] = useState(9); // pagination on client side
//   const [visibleCount, setVisibleCount] = useState(pageSize);
//   const abortRef = useRef(null);

//   const userRole = localStorage.getItem("role");
//   const userId = localStorage.getItem("userId");

//   useEffect(() => {
//     abortRef.current = new AbortController();
//     const signal = abortRef.current.signal;

//     const fetchPackages = async () => {
//       setLoading(true);
//       setError(null);
//       try {
//         let response;
//         if (userRole === "event-manager" || userRole === "event-agency") {
//           response = await api.getManagerPackages(userId, { signal });
//         } else {
//           response = await api.getAllPackages({ signal });
//         }
//         // assume response.data is array
//         setPackages(Array.isArray(response.data) ? response.data : []);
//       } catch (err) {
//         if (err.name !== "AbortError") {
//           console.error(err);
//           setError("Failed to fetch packages. Please try again.");
//         }
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPackages();

//     return () => {
//       abortRef.current?.abort();
//     };
//   }, [userRole, userId]);

//   // optimistic delete
//   const handleDelete = async (packageId) => {
//     const confirmed = window.confirm("Are you sure you want to delete this package?");
//     if (!confirmed) return;

//     const prev = packages;
//     setPackages((p) => p.filter((x) => x._id !== packageId));

//     try {
//       await api.deletePackage(packageId);
//       // success - already removed
//     } catch (err) {
//       console.error(err);
//       setPackages(prev); // rollback
//       setError("Failed to delete package. Please try again.");
//     }
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full max-w-6xl">
//           {Array.from({ length: 6 }).map((_, i) => (
//             <PlaceholderCard key={i} />
//           ))}
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
//         <div className="max-w-xl w-full text-center">
//           <div className="bg-red-50 border border-red-200 text-red-700 p-6 rounded-lg mb-6">
//             <strong className="block text-lg">Error</strong>
//             <p className="mt-2">{error}</p>
//           </div>
//           <div className="flex gap-3 justify-center">
//             <button
//               onClick={() => {
//                 setError(null);
//                 setLoading(true);
//                 // refetch (simple way)
//                 window.location.reload();
//               }}
//               className="px-4 py-2 bg-[#FF4C18] text-white rounded-lg"
//             >
//               Retry
//             </button>
//             <Link to="/" className="px-4 py-2 bg-white border rounded-lg">
//               Return Home
//             </Link>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // empty state
//   if (!packages.length) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
//         <div className="max-w-2xl w-full text-center bg-white p-8 rounded-lg shadow-sm">
//           <h2 className="text-2xl font-semibold mb-2">No packages found</h2>
//           <p className="text-gray-600 mb-6">
//             There are no packages available right now. If you're a manager, create your first package to get started.
//           </p>
//           {userRole === "event-manager" || userRole === "event-agency" ? (
//             <Link
//               to="/create-package"
//               className="inline-block px-6 py-2 bg-purple-600 text-white rounded-lg"
//             >
//               Create a Package
//             </Link>
//           ) : (
//             <Link to="/" className="inline-block px-6 py-2 bg-[#FF4C18] text-white rounded-lg">
//               Browse Events
//             </Link>
//           )}
//         </div>
//       </div>
//     );
//   }

//   // visible packages pagination
//   const visiblePackages = packages.slice(0, visibleCount);
//   const canLoadMore = visibleCount < packages.length;

//   return (
//     <main className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 md:gap-0 mb-10">
//           <div className="space-y-2">
//             <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
//               {userRole === "event-manager" || userRole === "event-agency"
//                 ? "Create event packages"
//                 : "Browse event packages"}
//             </h1>
//             <p className="text-sm text-gray-600 max-w-2xl">
//               {userRole === "event-manager" || userRole === "event-agency"
//                 ? "Build personalized event packages tailored to your clients’ needs."
//                 : "Browse ready-to-book event packages — hassle-free celebration solutions."}
//             </p>
//           </div>

//           <div className="flex items-center gap-3">
//             {userRole === "event-manager" || userRole === "event-agency" ? (
//               <Link
//                 to="/create-package"
//                 className="inline-flex items-center justify-center whitespace-nowrap bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
//               >
//                 Create New Package
//               </Link>
//             ) : (
//               <Link
//                 to="/packages?filter=popular"
//                 className="inline-flex items-center justify-center whitespace-nowrap bg-[#FF4C18] hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#FF4C18]"
//               >
//                 Browse popular
//               </Link>
//             )}
//           </div>
//         </div>

//         {/* Grid */}
//         <section aria-label="packages grid">
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             {visiblePackages.map((pkg) => (
//               <PackageCard
//                 key={pkg._id}
//                 pkg={pkg}
//                 canEdit={userRole === "event-manager" || userRole === "event-agency"}
//                 onDelete={handleDelete}
//               />
//             ))}
//           </div>

//           {/* Load more */}
//           {canLoadMore && (
//             <div className="mt-8 flex justify-center">
//               <button
//                 onClick={() => setVisibleCount((c) => c + pageSize)}
//                 className="px-5 py-2 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-gray-50"
//               >
//                 Load more
//               </button>
//             </div>
//           )}
//         </section>
//       </div>
//     </main>
//   );
// };

// export default Packages;
